import script from "./SelectChatWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectChatWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./SelectChatWrapper.vue?vue&type=style&index=0&id=73873ed2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73873ed2"]])

export default __exports__